// src/components/ArticleCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const truncateText = (html, wordLimit) => {
  if (!html) return '';
  const text = html.replace(/<[^>]*>/g, '');
  const words = text.split(/\s+/);
  return words.length <= wordLimit ? text : words.slice(0, wordLimit).join(' ') + '…';
};

const ArticleCard = ({ post }) => {
  const { slug = '#', title = 'Untitled Post', excerpt = '', featuredMedia, categories, author, dateTime } = post || {};
  const category = categories?.[0]?.name || 'Uncategorized';
  const authorName = author?.name || 'Oolook Team';
  const authorAvatar = author?.avatarUrl;
  const plainTitle = title.replace(/<[^>]*>/g, '');

  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl bg-dark-card/40 border border-white/10 transition-all duration-300 ease-in-out hover:border-dark-accent-start/50 hover:shadow-2xl hover:shadow-dark-accent-start/10">
      {featuredMedia?.source_url && (
        <Link to={`/blog/${slug}`} className="block aspect-square overflow-hidden">
          <img 
            className="h-full w-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105" 
            src={featuredMedia.source_url} 
            alt={plainTitle}
          />
        </Link>
      )}
      <div className="flex flex-1 flex-col p-6">
        <div className="flex-1">
          <p className="text-sm font-medium text-dark-accent-start">
            <Link to={`/blog/category/${category.toLowerCase().replace(/\s+/g, '-')}`} className="hover:underline">{category}</Link>
          </p>
          {/* ✅ FIX: The Link is now the h3 element itself to prevent double titles */}
          <Link to={`/blog/${slug}`}>
            <h3 className="mt-2 text-lg font-semibold text-dark-text-primary group-hover:text-white" dangerouslySetInnerHTML={{ __html: title }} />
          </Link>
          <p className="mt-3 text-sm text-dark-text-secondary" dangerouslySetInnerHTML={{ __html: truncateText(excerpt, 15) }} />
        </div>
        <div className="mt-6 flex items-center">
          <div className="flex-shrink-0">
            <Link to={`/blog/author/${author?.id || 1}`}>
              <span className="sr-only">{authorName}</span>
              {authorAvatar ? (
                <img className="h-10 w-10 rounded-full" src={authorAvatar} alt={authorName} />
              ) : (
                <div className="h-10 w-10 rounded-full bg-dark-card flex items-center justify-center text-dark-text-primary font-bold">{authorName.charAt(0)}</div>
              )}
            </Link>
          </div>
          <div className="ml-4">
            <p className="text-sm font-semibold text-dark-text-primary">
              <Link to={`/blog/author/${author?.id || 1}`} className="hover:underline">{authorName}</Link>
            </p>
            <div className="flex space-x-1 text-xs text-dark-text-secondary/70">
              <time dateTime={dateTime}>{new Date(dateTime).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</time>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ArticleCard;